// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-orm-list-table[data-v-7069b868] tr:nth-child(2n-1){background-color:#f0f6fc}", ""]);
// Exports
module.exports = exports;
